import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import useMusioApi from "@/contexts/client/musio-client-context";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import { ReactComponent as Logo } from "@/assets/musio-logos/logo_center_top.svg";
import { useLocation, useSearchParams } from "wouter";
import { SEARCH_PARAM_TOKEN_KEY } from "@/features/recovery";
import { NotificationRow } from "@/components/ui/notification-row";

const ERROR_RESET_EMAIL = "There was an error confirming your email"
const CONFIRMATION_EMAIL_RESET = "Email successfully changed"

export default function ResetEmail() {
  const [_, navigate] = useLocation();
  const { musioApi } = useMusioApi();

  const [params] = useSearchParams();
  const token = params.get(SEARCH_PARAM_TOKEN_KEY);

  if (!token) {
    navigate("~/error");
    return;
  }

  const { isError, isPending } = musioApi.useQuery("get", "/user/email", {
    params: {
      query: {
        token
      }
    }
  });

  return (
    <div className="flex flex-col items-center justify-center font-inter space-y-2 p-4">
      <div className="w-[128px] h-[128px] flex-shrink-0 flex justify-center items-center">
        <Logo />
      </div>
      <Card className="flex items-center justify-center flex-col musio-glass w-full max-w-[478px] h-full">
        <CardHeader className="flex items-center justify-center card-header-padded">
          <div className="flex items-center justify-between text-musio-lilac">
            <CardTitle className="text-[30px]">Reset Email</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="w-full space-y-2 card-content-padded flex flex-col justify-center items-center">
          {isPending == false ?
            < NotificationRow intent={isError ? "error" : "success"}>
              {isError ? ERROR_RESET_EMAIL : CONFIRMATION_EMAIL_RESET}
            </NotificationRow> : null
          }
        </CardContent>
        <CardFooter className="p-4 w-full flex flex-col justify-center items-center gap-2">
          {isPending ? (
            <LoadingIndicator />
          ) : (
            <Button
              type="button"
              className="w-full border-primary bg-musio-mid-gray font-bold text-musio-lilac border-none"
              variant="outline"
              onClick={e => {
                e.preventDefault();
                navigate("~/login");
              }}
            >
              Return
            </Button>
          )}
        </CardFooter>
      </Card>
    </div >
  );
};
